<template>
  <div>
    <template v-if="viewItem == null">
      <div class="d-flex mb-4">
        <span class="ml-auto mr-2 align-self-center text-h6 ">查詢： </span>
        <v-text-field
          style="max-width: 300px;"
          v-model="searchText"
          label="關鍵字"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>
      </div>

      <the-view-item-list :itemList="dataList" @select="showContent"></the-view-item-list>

      <v-pagination
        v-if="resourceList.length > 10"
        class="mt-4"
        v-model="page"
        :length="6"
        color="primary_light_1"
        dark
      ></v-pagination>
    </template>
    <template v-else>
      <div v-html="viewItem.content"></div>
    </template>
  </div>
</template>

<script>
import TheViewItemList from "@/components/TheViewItemList";
import dayjs from "dayjs";

export default {
  name: "Regulations",
  components: { TheViewItemList },
  data() {
    return {
      searchText: "",
      page: 1,
      resourceList: [
        {
          id: "01",
          class: "章程法令規章",
          image: "",
          title: "教育積分認定辦法",
          date: "2019-12-17",
          content: `<div class="章程法令規章-規章-教育積分認定辦法內容">
        <div class="章程法令規章-規章-教育積分認定辦法內容__4329e61acb4d4577a97742849d337ef4 headline">
          教育積分認定辦法
          <br />
          <br />民國九十五年一月十四日 / 第一屆第二次理監事會通過
          <br />
          <br />第一條
          台灣血管外科學會(以下簡稱本會)，為提昇醫療服務品質，鼓勵醫師在職進修追求醫學新知，推展血管外科醫學，特由本會教育委員會﹝以下簡稱本委員會﹞制訂定血管外科繼續教育積分認定辦法﹝以下簡稱本辦法﹞。
          <br />
          <br />第二條 本委員會及本辦法依據「台灣血管外科學會組織章程」制訂。
          <br />
          <br />第三條
          本辦法所稱繼續教育課程，包括本會及各教學醫院或醫事團體所舉辦有關血管外科醫學、醫學倫理、醫療相關法規，以及醫療品質之繼續教育課程。其中後三項合計至少應達總積分10%。
          <br />
          <br />第四條
          各種繼續教育課程活動申請本會繼續教育積分認定，須向本委員會提出積分認定申請文件及出席活動證明辦法：
          <br />
          <br />1. 各種教育訓練活動的繼續教育積分數之認定由本委員會為之。
          <br />
          <br />2.
          非本會所舉辦之學術研討會、學術演講或繼續教育課程，須為血管外科相關內容，並對外公開（於其他醫院張貼演講公告、或於網站公佈訊息…等）接受院外人士前往聽講者，始得向本會申請繼續教育積分認定，且須在開辦
          <br />
          前「30天」來函申請，未於期限內申請者恕不受理。
          <br />
          <br />3.
          申請繼續教育積分之認定，來函需註明舉辦之時間、地點、活動名稱、演講者姓名及科別、演講內容摘要、聯絡人及聯絡電話等資料，並附回郵信封。
          <br />
          <br />4.
          各單位辦理之繼續教育課程，應該向本委員會提出出席活動證明辦法，並且於活動現場提供本委員會認可之「繼續教育訓練出席簽名單」。
          如果主辦單位提供出席證明，應於課程結束後依實際參加情形發給證明，請勿於報到 <br />
          時即發給出席之證明。
          <br />
          <br />5. 主辦單位應於繼續教育課程結束後七天內，將「繼續教育訓練出席簽名單」寄回本會。
          <br />
          <br />第五條 申請血管外科繼續教育積分之教育訓練活動應該符合本會之宗旨，繼續教育積分認定標準如下：
          <br />
          <br />一、參加血管外科醫學或相關的學術會議，申請繼續教育積分者須附會議參加証影本，並註明會員號碼及姓名。繼續教育積分認定標準如下（若以視訊會議舉行者，積分均減半計算）：
          <br />
          <br />1. 參加本會年會或與外科醫學會合辦年會，每次積分60分。
          <br />
          <br />2. 參加本委員會安排的學術會議，每小時績分3分，每次至多30分。
          <br />
          <br />3. 參加其他外科次專科定期醫學會（需事先認定），每小時積分1分，每次至多10分。
          <br />
          <br />4. 參加本會認可之國際性血管外科定期醫學會，每小時積分3分，每次至多30分。
          <br />
          <br />二、血管外科醫學或相關的學術會議發表論文，申請繼續教育積分者須附會議議程的封面影本，並提供論文發表的日期、時間、地點、題目、演講者姓名等資料。繼續教育積分認定標準如下：：
          <br />
          <br />1. 於本會年會發表論文，每次積分20分。若是單一病例報告論文發表，每次積分10分。
          <br />
          <br />2. 國內其他次專科定期醫學會發表血管外科的論文，每次積分10分。
          <br />
          <br />3. 國際性血管外科定期醫學會發表論文，每次積分20分。
          <br />
          <br />4. 國際性其他次專科定期醫學會發表血管外科論文，每次積分10分。
          <br />
          <br />三、血管外科論文刊登於醫學期刊，依刊登雜誌(J)、作者排名（A）、論文性質（C）給分，J×A×C=積分（採四捨五入）。每篇最高不超過積分100分。
          <br />
          <br />1.刊登雜誌依發表之年份或當年之SCI定之：
          <br />
          <br />a. I.F≧10者 12分。
          <br />
          <br />b. 10＞I.F≧7 者 8分。
          <br />
          <br />c. 7＞I.F≧5者（或排名10%以內）6分。
          <br />
          <br />d. 排名25%以內者（或I.F3.000以
        </div>
      </div>`,
          isAdvertising: false,
          isLogin: true
        },
        {
          id: "02",
          class: "章程法令規章",
          image: "",
          title: "專科醫師甄審辦法",
          date: "2019-09-02",
          content: `<div class="章程法令規章-規章-專科醫師甄審辦法內容">
        <div class="章程法令規章-規章-專科醫師甄審辦法內容__40fbfc27b4614f3b885ea493128a180c headline">
          專科醫師甄審辦法
          <br />
          <br />台灣血管外科學會專科醫師甄審辦法 / 民國九十五年一月十四日 / 第一屆第二次理監事會通過
          <br />
          <br />第一章 總則 <br />第一條
          <br />台灣血管外科學會（以下簡稱本會）為符合各國醫學教育進步之趨勢，特制訂血管外科專科醫師甄審原則，其目的為培養優秀血管外科醫師及發展國內有關血管外科醫療之學識、技術、設備及研究，使能對國民之健康有更大之貢獻。
          <br />第二條
          <br />本會為一依法設立之民間學術團體，其認定之合格血管外科專科醫師，僅限於其對血管外科學識、技術及經驗。對政府所頒佈之有關醫師資格及醫師開業之各項法規，並不抵觸。
          <br />第二章 血管外科專科醫師甄審委員會 <br />第三條
          <br />血管外科專科醫師甄審委員會（以下簡稱本委員會），依台灣血管外科學會組織章程組成。 <br />第四條
          <br />本委員之職責為： <br />審核申請甄試醫師之資歷。
          <br />聘請血管外科專家及資深望重之血管外科醫師，組成血管外科專科醫師甄審小組，辦理血管外科專科醫師之各項甄審、命題、及評分。
          <br />審核及修改血管外科專科臨床訓練之計劃及課程。
          <br />審核擔任血管外科專科臨床訓練之醫學中心及醫院之作業情況及設備。
          <br />審核各血管外科專科臨床訓練指導醫師之資歷。 <br />第五條
          <br />血管外科專科醫師甄審委員，由本委員會主任委員於下列各機構中，選擇下列之適當人員中聘任之。
          <br />台灣血管外科學會理監事若干人。 <br />各醫學院或各大教學醫院資深血管外科醫師若干人。
          <br />資深望重之執業血管外科醫師若干人。 <br />第三章 血管外科專科醫師甄審考試應具備之資格 <br />第六條
          <br />申請血管外科專科醫師甄試者，須具備下列各款資格：
          <br />曾在國內外公私立大學之醫學院、獨立之醫學院、或醫學專科學校畢業並有該醫學院之畢業證書。
          <br />曾通過考試院之醫師考試，並持有該院之醫師考試合格證書。 <br />持有中央衛生主管機關之醫師證書。
          <br />取得外科專科醫師資格者。 <br />參加本會取得一般會員醫師資格一年以上者。
          <br />於本會認可之專科醫師訓練機構接受訓練滿二年；或已有國外血管外科專科醫師資格，經理監事會審核通過者，得參加甄審考試。但具備下列全部資格，經甄審委員會審查通過且經理監事會認可者，得免筆試：
          <br />(1) 領有本會認可之國家血管外科專科醫師證書。 <br />(2) 最近三年仍繼續從事血管外科診療工作。 <br />(3)
          目前任職於本會認可之血管外科專科訓練機構。 <br />(4) 具有卓著血管外科醫學研究績效者。
          <br />參考本學會繼續教育積分認定辦法，得本會繼續教育積分100分﹝含以上﹞。
          <br />免試條款：本學會預定2011年開始實施次專科醫師甄試，惟於次專科醫師甄試實施前具備下列全部資格，經甄審委員會審查通過且經理監事會認可者，得免甄試成為本會專科醫師：
          <br />(1) 取得外科專科醫師資格者。 <br />(2) 加入本學會成為一般會員滿一年。 <br />(3)
          參考本學會繼續教育積分認定辦法，得本會繼續教育積分100分﹝含以上﹞。 <br />(4) 此條款於2011年1月1日自動失效。
          <br />第四章 申請血管外科專科醫師甄審之程序 <br />第七條
          <br />申請甄試之醫師，須向甄審委員會提出下列各款申請書，推薦書及其他證明文件。
          <br />血管外科專科醫師甄審之申請書。 <br />指導該醫師之專科指導醫師兩位之推薦書。
          <br />外科之專科醫師證書及兩年血管外科專科臨床訓練期滿之證明書，或國外血管外科專科醫師證書。 <br />第八條
          <br />本委員會定期召開會議，審查申請甄試醫師之資歷及其所提出之證明文件。甄審合格者，方能參加考試。
          <br />第九條
          <br />血管外科專科醫師之考試，分為二部份，第一部份為筆試，第二部份為口試，申請甄試之醫師，須先參加第一部份之筆試，當筆試及格後，始能參加第二部份之口試：
          <br />一、血管外科專科醫師甄審筆試部份：
          <br />血管外科專科醫師甄審筆試部份，每年舉行一次，筆試之日期、地點及費用，由理監事會決定後公佈或個別通知之。
          <br />筆試採用選擇題，時間為三小時，內容分兩部，前一部份有關血管外科之各種基礎醫學（試題佔三分之一），後一部份由臨床血管外科學出題（試題佔三分之二）。
          <br />甄審委員會由當地之醫學中心或教學醫院中之血管外科指導醫師及當地具有專長之著名血管外科醫師中，於考試二個月前選聘五至十人，組成筆試小組，擔任命題及評分，為無給職並於考試後解散之。
          <br />筆試小組於評定成績後，公佈標準答案並將成績呈報甄審委員會，由甄審委員會通知各申請甄試醫師及格或不及格，但不公布分數。
          <br />筆試及格有效期為兩年。
          <br />如筆試不及格，可於下次舉行筆試時申請再試，如連續三次不及格時，則須在職訓練滿壹年並取得證明以後再申請參加筆試。
          <br />二、血管外科專科醫師甄審口試部份：
          <br />血管外科專科醫師甄審口試部份，每年亦舉行一次，口試之日期、地點及費用由理監事會決定後公佈或個別通知之。
          <br />口試在指定之醫學中心或教學醫院內舉行，內容包括： <br />（1）血管外科科疾病之診斷及處理。
          <br />（2）血管疾病之基礎醫學。 <br />（3）血管疾病之流行病學。
          <br />（4）非侵襲性血管檢查、血管攝影等血管影像檢查。
          <br />甄審委員會由當地之醫學中心或教學醫院中之血管外科指導醫師及當地具有專長之著名血管外科醫師中，選聘五至十人，組成口試小組，擔任口試及評分，為無給職並於考試後解散之。
          <br />口試小組於評定口試成績後，呈報甄審委員會，由甄審委員會通知申請甄試醫師及格或不及格，但不公佈分數。
          <br />如口試不及格，可於下次舉行試時申請再試，如連續二次不及格時，則須重新參加筆試，筆試及格後，再由請參加口試。
          <br />第十條
          <br />當申請甄試醫師於筆試及口試二部份考試及格，由甄審委員會主任委員報請台灣血管外科學會理監事會，發給血管外科專科醫師合格之證書。並公佈其姓名地址。
          <br />第五章 申請血管外科專科醫師必備之臨床訓練綱要 <br />第十一條
          <br />申請血管外科專科醫師甄試者，須具有一年實習醫師訓練完成後之兩年一般外科住院醫師之臨床訓練。
          <br />第十二條 <br />在本會認可之血管外科專科醫師訓練機構，完成兩年血管外科專科訓練。 <br />第十三條
          <br />兩年血管外科專科臨床訓練之課程及時間之分配，須依據本會專科醫師訓練內容規定施行。並應事先送請甄審委員會備查。
          <br />第十四條 <br />血管外科專科醫師臨床訓練受訓期滿，受訓醫師必需熟悉各種血管疾病之診斷、急救及治療。
          <br />第十五條 <br />血管外科專科醫師應遵本會規定，定時接受繼續教育訓練之計畫。 <br />第十六條
          <br />專科醫師訓練若無法連續接受二年訓練，最長完成訓練時間需在五年內完成，而分段接受訓練者，期間不得間隔三年。
          <br />第六章 血管外科專科醫師證書的頒發、有效期限、與更換執照條件 <br />第十七條
          <br />經本會甄審辦法通過成為本會血管外科專科醫師，可得申請本會血管外科專科醫師證書。 <br />第十八條
          <br />本會血管外科專科醫師證書有效期限六年，期限屆滿得申請更換執照。 <br />第十九條
          <br />申請更換血管外科專科醫師執照之醫師，須持續執行符合本會宗旨之血管外科臨床診療業務，接受本會認可之繼續教育訓練，且於專科醫師有效期限六年內取得本會繼續教育績分達600分以上，且不得有一年之積分為零分。若因故於
          <br />換証期限內未能取得需要之積分者，得申請展延，經本委員會同意。展延以一次為限，為期一年。 <br />第七章
          擔任血管外科專科醫師臨床訓練機構資格之認定及審核 <br />第二十條
          <br />擔任血管外科專科醫師臨床訓練之診療機構，須為評鑑合格之教學醫院並且作業時間達一年(含以上)，並合於下列各款全部條件。
          <br />具有非侵襲性血管檢查室設備而實際作業者。 <br />具有完整血管攝影與其他血管影像檢查設備而實際作業者。
          <br />具有傳統血管外科手術與血管內手術設備而實際作業者。 <br />申請血管外科專科醫師訓練機構者，其必備條件：(1)
          為每年非侵襲性血管檢查200例(含)以上。(2) 每年血管攝影檢查（含MRA、CTA）100例(含)以上。(3)
          每年周邊血管外科手術及血管腔內手術150例(含)以上。(4) 主動脈或腔靜脈傳
          <br />統手術或血管腔內手術5例﹝含﹞以上。 <br />必備條件准向甄審委員會報准後，與其他訓練機構共同訓練。
          <br />第二十一條
          <br />擔任血管外科專科臨床訓練之診療機構，至少一人有台灣血管外科學會認定合格之專任血管外科專科訓練指導醫師。整個訓練過程，可不局限於同一機構。
          <br />第二十二條
          <br />申請擔任血管外科專科臨床訓練之診療機構，向甄審委員會申請，開始接受訓練前，須向本委員會提出下列各款文件：
          <br />參加血管外科專科臨床訓練之申請書。 <br />該診療機構之組織及設備之說明書。
          <br />該診療機構最近一年之血管外科醫務作業報告書。 <br />該診療機構之首長及醫務人員之名冊及學歷與經歷。
          <br />第二十三條
          <br />擔任血管外科專科臨床訓練診療機構，須先向本委員會，申請擔任此種訓練工作，於認可後，始能接受醫師，參加訓練。
          <br />第二十四條
          <br />甄審委員會在接到診療機構申請書及附件後，應先指定委員二人以上之調查，根據調查報告，開會討論審核，如認為合格時，經理事會認可，授予該診療機構血管外科專科臨床訓練醫院合格證明書。
          <br />第二十五條
          <br />本委員會應按期指派委員，實施調查參加血管外科專科臨床訓練之診療機構之作業狀況及訓練狀況，作成報告，向甄審委員會提出。甄審委員會議決定某診療機構須作某種之改進時，得函請該診療機構作該項作業之改進，如一年以
          <br />後甄審委員會認為該診療機構未曾作該項業務改進之努力，或該項改進未達到甄審委員會之要求時，甄審委員會得建議本會，取消該診療機構臨床訓練血管外科專科醫師之資格。
          <br />第二十六條 <br />血管外科專科臨床訓練機構評鑑辦法：
          <br />每年一月底前接受申請血管外科專科醫師訓練機構評鑑，實施評鑑每年一次。
          <br />經評鑑後，準合格之訓練機構可於每年一月底前提出申請評鑑，每一年可申請再評鑑。
          <br />經評鑑後，合格之訓練機構每三年由本會統一複審一次。
          <br />評鑑結果經理監事會通過之日期，其專科醫師訓練期限可回溯一年。
          <br />每年八月本會發函各訓練機構，根據甄審委員會評鑑所核定之員額限制，請其於八月底前將訓練醫師名單列冊並附各相關之外科專科醫師證書與訓練起迄時間等資料報本會審核後，由本會發予訓練許可證明，爾後被訓練醫師才可參
          <br />加血管外科專科醫師報考甄審。 <br />第八章 血管外科專科臨床訓練指導醫師之資格 <br />第二十七條
          <br />擔任臨床訓練血管外科專科醫師之指導醫師，須具備下列所有資歷：
          <br />本規則所規定之血管外科專科指導醫師資格，須取得專科醫師證書滿五年。
          <br />在經本會認可之國內外診療機構擔任十年以上之臨床工作。
          <br />在醫學院或教學醫院擔任五年以上之臨床教學工作，具有豐富之經驗而被認為有血管外科專長者。
          <br />2011年1月1日前具上述三項資格即可提出申請，本委員會審查並經理監事會通過成為血管外科專科醫師之指導醫師。
          <br />專科醫師最近五年內曾在SCI登錄有案的血管相關雜誌中，以第一作者或通訊作者發表過〈或被接受〉有關血管疾病或治療的原著或綜合評述。（此條款2011年1月1日生效）
          <br />第二十八條
          <br />擔任臨床訓練血管外科專科醫師之指導醫師，須先向本委員會提出其資歷之證明文件，本委員會每年接受申請二次，於每年一月及七月底前申請，經審查合格，承認其資格後，始能擔任指導工作。
          <br />第二十九條 <br />指導醫師須負責下列各款工作：
          <br />為接受血管外科專科臨床訓練之醫師，計劃二年之訓練課程。 <br />直接指導接受臨床訓練醫師之各項臨床工作。
          <br />向甄審委員會報告訓練醫師之臨床訓練進度及成績。 <br />第三十條
          <br />臨床訓練血管外科專科醫師之指導醫師應專任為無給職，當指導醫師因故喪失其醫師資格，或喪失其血管外科專科醫師資格，或當本委員會認為其擔任訓練工作，未盡其指導責任時，得建議取消其指導醫師之資格。
          <br />第九章 專科醫師資格之喪失 <br />第三十一條
          <br />具有專科醫師資格之血管外科醫師，如有行為越規，足以損壞台灣血管外科學會之名譽及聲望時，經台灣血管外科學會理監事會通過，得取消其專科醫師之資格。
          <br />第三十二條
          <br />具有專科醫師資格之血管外科醫師，觸犯下列任何一項者，經台灣血管外科學會理監事會調查證實，並經理監事會通過後，可取消該醫師之專科醫師資格。
          <br />觸犯中華民國之刑法，並經法院三審認定者。 <br />經任何級政府機構判罰其停止在中華民國境內執行醫師業務者。
          <br />執行醫師業務時，犯有違背醫德，誇大荒謬之宣傳，欺詐病人及其他不道德之行為者。 <br />第三十三條
          <br />凡經台灣血管外科學會理監事會取消專科醫師資格者，應無條件繳回專科醫師證書。 <br />第十章 附則
          <br />第三十四條 <br />本規則定於中華民國九十四年訂定，九十五年一月一日起施行。 <br />第三十五條
          <br />本規則如有未盡善處，由甄審委員會建議，經台灣血管外科學會理監事會議決後，修改或增訂之，並呈內政部備案後實施。
        </div>
      </div>`,
          isAdvertising: false,
          isLogin: true
        },
        {
          id: "03",
          class: "章程法令規章",
          image: "",
          title: "專科醫師訓練內容",
          date: "2019-09-01",
          content: `<div class="章程法令規章-規章-專科醫師訓練內容內容">
        <div class="章程法令規章-規章-專科醫師訓練內容內容__b54b51dffbb549ff820c502baa21fcf3 headline">
          專科醫師訓練內容
          <br />
          <br />台灣血管外科學會專科醫師訓練內容 / 民國九十五年一月十四日 / 第一屆第二次理監事會通過
          <br />
          <br />一、擔任本會血管外科臨床訓練之診療機構實際作業最低要求條件：
          <br />
          <br />1. 周邊血管超音波檢查每年200例﹝含﹞以上。 <br />2.
          周邊血管或主動脈血管攝影檢查（含MRA及CTA）每年100例﹝含﹞以上〈含放射線科及血管外科之術中血管攝影〉。 <br />3.
          周邊血管手術每年150例﹝含﹞以上。含周邊動脈血管傳統手術(open surgery)或血管腔內手術(endovascular surgery)
          ，靜脈手術，以及血液透析用血管通路手術。 <br />4. 主動脈或腔靜脈的傳統手術或血管內支架手術每年5例﹝含﹞以上。
          <br />5. 訓練機構之訓練項目中有不符合學會認定資格者，可委託其他被認可之機構，代訓練專科醫師。
          <br />
          <br />二、申請本會血管外科專科醫師之臨床訓練項目、期間(月數)及病例數最低要求：
          <br />
          <br />訓練項目 <br />累積訓練月數 <br />累積訓練例數
          <br />
          <br />非侵襲性周邊血管檢查（含動脈及靜脈） <br />1月 <br />20例
          <br />
          <br />血管外科門診診斷及治療 <br />2月
          <br />
          <br />診斷性血管射影及血管影像檢查（核磁共振血管射影或電腦斷層血管射影） <br />1月
          <br />
          <br />血管疾病病人診療〈含會診〉 <br />2月
          <br />
          <br />血管相關學術會議及研究 <br />血管疾病藥物治療及照護 <br />血管外科傳統手術 <br />血管內手術 <br />18月
          <br />為各項血管傳統手術或血管內手術施術者及第一助手者共100例。 <br />合計 <br />24月
          <br />
          <br />附註：
          <br />
          <br />(1) 相關例數限制要求，將統一由學會設計登錄表格（內應含病患姓名、病歷號與主診斷等資料）。 <br />(2)
          血管手術包括aorta and lower extremity arteries, brachiocephalic and upper extremity arteries, mesenteric and
          renal arteries, central and peripheral veins, <br />
          hemodialysis accesses.
        </div>
      </div>`,
          isAdvertising: false,
          isLogin: false
        },
        {
          id: "04",
          class: "章程法令規章",
          image: "",
          title: "智慧深耕獎(IUA)甄選辦法",
          date: "2019-09-01",
          content: `<div class="章程法令規章-規章-智慧深耕獎甄選辦法內容">
        <div class="章程法令規章-規章-智慧深耕獎甄選辦法內容__77933e59914847a3a803400707f7a915 headline">
          智慧深耕獎(IUA)甄選辦法
          <br />
          <br />2009/3/8
          <br />
          <br />1. 為鼓勵本會會員從事血管外科醫學相關研究，特定本辦法。
          <br />
          <br />2. 經費來源：2007 IUA經費盈餘孳息運用（專款專用），如有不足另行籌措經費或動支本金5萬元以內為限。
          <br />
          <br />3.
          凡本會會員（年會前），得以在年會前3年內完成之研究成果並完成正論文式全文參選。申請人必須為該論文之第一作者。每年每人限以一篇論文申請。曾於國內外獲獎之論
          <br />
          文不得參賽（被舉發證實者，取消資格並追回獎金及獎牌）。
          <br />
          <br />4.
          智深獎評選委員會就當年參選論文評分選出一至三名頒給優秀論文（paper）獎，並自投於大會年會之摘要（abstract），選出六至十二於大會中發表演說，選出一至三名頒
          <br />
          給傑出研究（investigation）獎。如評選委員三分之二（含）以上認為未達評分標準，可從缺（如第一名從缺）。評分標準包括：（1）主題及研究內容（2）研究地點以國內
          <br />
          為優先（3）對國內血管外科學有貢獻者。
          <br />
          <br />5.
          於年會期間公開表揚，頒發獎金及獎牌，優秀論文獎第一名獎金一至二萬元、第二名伍仟至一萬元、第三名三仟至伍仟元。（得獎論文將安排在年會中用英文發表演講）。
          <br />
          傑出研究獎之獎金由委員會決定，最高以不超過論文獎第三名獎金為原則。
          <br />
          <br />6.
          智深獎評選委員會委員共15名，七名常任委員名單：王水深、謝敏暲、游堂振、詹志洋、陳益祥、周迺寬、吳毅暉。另由當屆理事長指派七至八名委員(含當屆理事長為評選
          <br />
          委員會主任委員，學術主任委員為評選委員會執行長)。應謹守迴避原則考量。
          <br />
          <br />7. 申請時請附上論文各十五份。
          <br />
          <br />8. 申請截止日期：優秀論文（paper）獎年會前2個月。傑出研究（investigation）獎在年會截稿日。 <br />
          其他未盡事宜或修改由委員會決定，經理事會通過。修改事項亦同。
        </div>
      </div>`,
          isAdvertising: false,
          isLogin: false
        },
        {
          id: "05",
          class: "章程法令規章",
          image: "",
          title: "委員會組織簡則",
          date: "2019-09-01",
          content: `<div class="章程法令規章-規章-委員會組織簡則內容">
        <div class="章程法令規章-規章-委員會組織簡則內容__e4e3f8936d4d4089b24d9df59dc79d05 headline">
          委員會組織簡則
          <br />
          <br />甄審委員會 <br />(Membership committee)
          <br />
          <br />第一條：台灣血管外科學會為綜理本會有關會員入會及專科醫師之甄審，特設立「台灣血管外科學會甄審委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條以及行政院衛生署訂頒「專科醫師分科及
          <br />
          甄審辦法」十三條訂定之。 <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之業務及執行本委員會及理
          <br />
          監事會之決議。 <br />第三條：本委員會之任務如下： <br />
          審核會員申請資格，於理監事會提出與公佈。 <br />
          配合衛生署每年辦理血管外科專科醫師甄審事宜。 <br />
          制訂與修正一般會員、專科會員、與學會所規範的各種血管專家甄審原則。 <br />
          認證、印製、與頒發本學會會員證書、以及學會所規範的各種血管專家資格證書。 <br />
          審查繼續教育積分，並辦理證書之展延(換証)工作，包含血管外科專科醫師、以及學會所規範的各種血管專家資格證書。
          <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />學術委員會 <br />(Program committee)
          <br />
          <br />第一條：台灣血管外科學會為綜理有關血管外科學術性活動、及舉辦有關血管外科醫學之學術演講及研討會事宜，特設立「台灣血管外科學會學術委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條
          <br />
          訂定之。 <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，必須包括本會副秘書長，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之
          <br />
          業務及執行本委員會及理監事會之決議。 <br />第三條：本委員會之任務如下: <br />1.
          綜理本會各項學術活動，舉辦定期與不定期學術研討會。 <br />2.
          規劃本會學術會議之節目，審核投稿論文與選擇適當論文以利本會學術會 <br />
          議議程的進行。 <br />3. 辦理年度會員代表大會暨學術演講活動等相關事宜。 <br />4. 理監事會議與選舉事宜。
          <br />5. 負責向理事會推薦本會相關學術獎勵事宜。 <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />編輯委員會 <br />(Publications committee)
          <br />
          <br />第一條：台灣血管外科學會為綜理本會刊物出版事宜，特設立「台灣血管外科學會編輯委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條訂定之。
          <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之業務及執行本委員會及理
          <br />
          監事會之決議。 <br />第三條：本委員會之任務如下： <br />
          負責本會刊物的編輯，審核投稿文章。 <br />
          出版學會刊物事宜，包括有關出版財務與執行的建議。 <br />
          學會網站的發表與維護。 <br />
          對其他各種媒體發表有關血管醫學與健康的報導。 <br />
          推廣血管外科醫學新知。 <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />教育委員會 <br />(Education committee)
          <br />
          <br />第一條：台灣血管外科學會為綜理有關學會教育推廣事宜，特設立「台灣血管外科學會教育委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條訂定之。
          <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之業務及執行本委員會及理
          <br />
          監事會之決議。 <br />第三條：本委員會之任務如下： <br />
          促進血管外科教育訓練，醫療品質改善相關事宜及計畫之推動。 <br />
          定期與不定期辦理血管疾病、血管外科手術、血管內治療術、以及血管檢查等等訓練課程。 <br />
          制訂與修正血管外科專科醫師繼續教育積分認定辦法。 <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />研究委員會 <br />(Research committee)
          <br />
          <br />第一條：台灣血管外科學會為了推廣與整合國內對於血管疾病與治療的研究工作，而成立本委員會，特設立「台灣血管外科學會研究委員會」（以下簡稱本委員會）。
          <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之業務及執行本委員會及理
          <br />
          監事會之決議。 <br />第三條：本委員會之任務如下： <br />1.
          計畫與推動有關血管疾病與治療的基礎與臨床研究工作，並且尋求研究計畫。 <br />2.
          綜理國內有關血管外科手術與血管內手術的新式醫療技術與器材的研究應用。 <br />3.
          促進兩岸華人與世界各國的共同合作研究計畫。 <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />
          臨床委員會 <br />(Clinical practice committee)
          <br />
          <br />
          第一條：台灣血管外科學會為綜理有關血管外科臨床等業務，特設立「台灣血管外科學會臨床委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條訂定之。
          <br />第二條：本委員會設主任委員1人，由常務監事擔任主席，另聘委員2-
          4人，負責監察臨床執業情況。由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之
          <br />
          。負責處理本委員會之業務及執行本委員會及理監事會之決議。 <br />第三條：本委員會之任務如下 <br />1.
          參加政府衛生部門有關血管手術，血管腔內手術的相關會議，協助與統整政府制定相關規範。 <br />2.
          綜理國內各醫療院所執行血管外科手術、血管腔內手術、新式血管醫療技術的應用現況、與血管檢查室等等臨床業務，是否符合學會規範。
          <br />3. 訂定各種血管疾病及血管檢查室之診療指引(clinical guidelines)。 <br />4.
          討論並發表對各種血管疾病之共識聲明 (consensus statements)。 <br />5.
          制定各種血管手術、血管腔內治療、與血管檢查之報告標準 (reporting standards)。 <br />6.
          制定各種血管手術與血管內治療手術的「手術同意書附帶說明」。
          <br />第四條：本委員會會議由主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
          <br />
          <br />公共事務委員會 <br />(Public affairs committee)
          <br />
          <br />第一條：台灣血管外科學會為加強與血管外科醫學相關各國內、外醫學組織之聯繫，特設立「台灣血管外科學會公共事務委員會」（以下簡稱本委員會）。其組織簡則依據台灣血管外科學會章程第六條及第廿三條訂定之。
          <br />第二條：本委員會設主任委員1人，另聘委員2-
          4人，由理事長提經理事會通過後聘任之，其任期與當屆理監事任期同，委員因特殊原因無法勝任委員工作時，得由主任委員另聘委員擔任之。負責處理本委員會之業務及執行本委員會及理
          <br />
          監事會之決議。 <br />第三條：本委員會之任務如下： <br />1. 配合政府舉辦血管疾病的衛生教育宣導活動。 <br />2.
          本會與媒體組織之間的聯絡、協調、記者會等公共事務活動。 <br />3. 促進兩岸華人與國內外血管外科學會的交流活動。
          <br />4. 加強國內、外與血管外科醫學相關機關團體之關係。 <br />5.
          負責本學會對外之諮詢事項，以及醫療糾紛相關諮詢。 <br />第四條：本委員會會議主任委員召集，必要時得召開會議。
          <br />第五條：本委員會之決議，應有委員過半數之出席，出席委員較多數之同意，並經提報本會理事會通過後實施。
          <br />第六條：本簡則如有未盡事宜，悉依本會章程及有關法令規定辦理。
          <br />第七條：本簡則經本會理事會通過，報請主管機關核准後實施，修改時亦同。
        </div>
      </div>`,
          isAdvertising: false,
          isLogin: false
        }
      ]
    };
  },
  computed: {
    dataList() {
      return this.resourceList
        .map(({ id, title, date }) => ({ id, title, date }))
        .sort(({ date: mainDate }, { date: subDate }) => {
          if (dayjs(mainDate).isBefore(dayjs(subDate))) return 1;
          if (dayjs(subDate).isBefore(dayjs(mainDate))) return -1;
          return 0;
        });
    },
    viewItem() {
      return this.resourceList.find(({ id }) => id === this.$route.params.id);
    }
  },
  methods: {
    showContent(targetId) {
      this.$router.push({ name: "AboutBylawsRegulationsRegulationsItem", params: { id: targetId } });
    }
  }
};
</script>

<style lang="scss">
.章程法令規章-規章-教育積分認定辦法內容 {
  &__4329e61acb4d4577a97742849d337ef4 {
    color: #121a33;
  }
}

.章程法令規章-規章-專科醫師甄審辦法內容 {
  &__40fbfc27b4614f3b885ea493128a180c {
    color: #121a33;
  }
}
.章程法令規章-規章-專科醫師訓練內容內容 {
  &__b54b51dffbb549ff820c502baa21fcf3 {
    color: #121a33;
  }
}
.章程法令規章-規章-智慧深耕獎甄選辦法內容 {
  &__77933e59914847a3a803400707f7a915 {
    color: #121a33;
  }
}
.章程法令規章-規章-委員會組織簡則內容 {
  &__e4e3f8936d4d4089b24d9df59dc79d05 {
    color: #121a33;
  }
}
</style>
